import React, { useEffect, useState, useCallback, useContext } from 'react';
import {
    Button,
    Select,
    DatePicker,
    Form,
    message,
    Dropdown,
    Menu,
    Popconfirm,
    Modal,
    Typography,
    Tag,
    Upload,
    Radio,
    Input,
    Col,
    Space
} from 'antd';
import { useQuery, useMutation } from '@apollo/react-hooks';
import { Icon } from '@ant-design/compatible';
import { GET_DASHBOARD_ITEMS } from '../../graphql/queries'
import { UPDATE_DASHBOARD_ITEM } from '../../graphql/mutations'
import time from '../../utils/time'
import chart from '../../utils/chart'
import moment from "moment";
import { Fileuploader } from '@ap-evolved/evolved-ui.ui.fileuploader'
import { v4 as uuidv4 } from 'uuid'
import { QueryBuilder } from '@cubejs-client/react'
import FilterGroup from '../QueryBuilder/FilterGroup'
import dashboardFilter from '../../utils/dashboardFilter'
import useQueryUpdater from './useQueryUpdater'
import DateRangeSelect from './DateRangeSelect'
import styles from './styles'
import DimFilterSelect from './DimFilterSelect'
import MenuOptions from './MenuOptions'
import PropTypes from 'prop-types'
import FilterContext from './FilterContext'

const ExportModal = ({
    showModal,
    setShowModal
}) => {

    const { exportOptions, state, setState } = useContext(FilterContext)

    const [selectedOption, setSelectedOption] = useState(exportOptions[0])

    const handleOk = useCallback(async () => {
        setShowModal(false)
        await new Promise(resolve => setTimeout(resolve, 50))
        setState({
            ...state,
            export: true,
            reset: selectedOption.value.includes('all')
        })
    })

    return (
        <Modal
            title='Export dashboard'
            visible={showModal}
            onOk={handleOk}
            onCancel={() => { setShowModal(false) }}

        >
            <p>The dashboard will be exported as a PowerPoint presentation. How would you like the PPT to be generated?</p>
            <Radio.Group
                onChange={(e) => {
                    setSelectedOption(
                        exportOptions
                            .find(option =>
                                (option.value == e.target.value)
                            )
                    )
                }}
                defaultValue={exportOptions[0].value}
            >
                <Space direction="vertical">
                    {
                        exportOptions.map((option) => {
                            return (
                                <Radio value={option.value}>{`${option.text}`}</Radio>
                            )
                        })
                    }
                </Space>

            </Radio.Group>

        </Modal >
    )

}

ExportModal.propTypes = {
    showModal: PropTypes.bool.isRequired,
    setShowModal: PropTypes.func.isRequired
}
ExportModal.defaultProps = {
    showModal: false,
    setShowModal: null
}

export default ExportModal